/**
 * A config containing properties for Pagination
 */
var PaginationConfig = /** @class */ (function () {
    function PaginationConfig() {
    }
    return PaginationConfig;
}());
export { PaginationConfig };
//# sourceMappingURL=pagination-config.js.map